import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { handleResponse } from 'APIPackage/MainModule/common/handleResponse';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { ITerminationReason } from '../interfaces/ITerminationReason';

export async function fetchTerminationReasons(): Promise<ITerminationReason[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/termination-reasons`;
  const mockData = apiMockSwitcher<ITerminationReason[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
